import { Skeleton, TableCell } from '@/shared/ui';

import { DateTextVariants, useDateText } from '@/features/_shared/user';

type Props = {
  date: string | undefined | null;
  isLoading: boolean;
};

const DateCell = ({ date, isLoading }: Props) => {
  const { formatDateString } = useDateText();
  const formattedDate = date ? formatDateString(date, DateTextVariants.DAY_MONTH) : null;
  return (
    <TableCell align='right'>
      {isLoading && !date ? (
        <Skeleton
          variant='text'
          width={45}
          sx={{ ml: 'auto' }}
        />
      ) : (
        formattedDate
      )}
    </TableCell>
  );
};

export default DateCell;
